import Api from '../../../Api'
import { all } from 'redux-saga/effects'
import { combineReducers } from "redux";
import createTableFetcher from 'common/reducer/createTableFetcher'

const getFetcher = state => state.waas.containersProblematicServices.fetcher
export const fetcher = createTableFetcher('containersProblematicServices', Api.fetchContainersProblematicServices, getFetcher)

export const actions = {
    ...fetcher.actions
}

export default combineReducers({
    fetcher: fetcher.reducer
});

export function* containersProblematicServicesSaga() {
    yield all([
        fetcher.saga(),
    ])
}